export const formatDate = (value) => {
  const input = value.replace(/\D/g, ""); // Remove non-digit characters
  let formattedValue = input;

  if (input.length > 2) {
    formattedValue = `${input.slice(0, 2)}/${input.slice(2)}`;
  }
  if (input.length > 4) {
    formattedValue = `${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(
      4,
      8
    )}`;
  }

  return formattedValue;
};

const turkishMonths = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];

export const formatTurkishDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = turkishMonths[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export const getDaysAgo = (dateString) => {
  const advertDate = new Date(dateString);
  const today = new Date();
  const diffTime = today - advertDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return "Bugün";
  if (diffDays === 1) return "Dün";
  return `${diffDays} gün önce`;
};
